import log from 'loglevel'

export function getLogger() {
  var level = process.env.ENV
  log.setLevel(level === 'PROD' ? log.default.levels.ERROR : log.default.levels.DEBUG)
  return log
}
